<template>
  <div
    :id="anchorId"
    class="box_title_area"
  >
    <h3
      class="service-title-b"
    >
      <slot />
    </h3>
    <p>
      <slot name="sub-title" />
    </p>
    <slot name="additional" />
  </div>
</template>

<script>
export default {
  name: 'MpnSectionTitle',
  props: {
    anchorId: {
      type: String,
      default: 'anchor me',
    },
  },
};
</script>
